import { useSelector, useDispatch } from "react-redux";
import { apiUrlB2B } from "../utils/constants";
import { setUser } from "../store/reducers/user";
import { axiosInstance, getJwtExpiration } from "../utils/helper";
import { useEffect } from "react";
import { showError } from "../ufood-x/hook/useError";
import { useLocation } from "react-router-dom";

const useRelogin = () => {
    const dispatch = useDispatch();
    const user = useSelector((store) => store?.user);
    const location = useLocation();

    const reloginUV = async () => {
        try {
            let token = null;
            const res = await axiosInstance.post(`${apiUrlB2B}auth/relogin-uv`,
                {
                    customerId: user?.customerID,
                    token: user?.token
                },
            );

            if(res?.data?.responseCode != 200) {
                showError({
                    title: "please relogin",
                });
            }

            token = res?.data?.data?.token;

            dispatch(
                setUser({
                    token,
                    tokenExpiresAt: getJwtExpiration(token),
                })
            );
        } catch (error) {
            console.log('error: ', error);
        }
    }

    useEffect(() => {
        const time = Math.floor(Date.now() / 1000);
        
        if(time > user?.tokenExpiresAt && user?.is_b2b) {
            reloginUV();
        }
    }, [location]);
};

export default useRelogin;